<script setup lang="ts">
import type { GuestListFilters } from "./types"
import { onMounted, reactive, watchEffect } from "vue"
import { Drawer, Select } from "@/components/ui"
import { useTranslation } from "@/composables"
import { GuestListFiltersDrawerKey } from "@/symbols"

interface GuestListFiltersDrawerProps {
  filters: GuestListFilters
}

const props = defineProps<GuestListFiltersDrawerProps>()

const emit = defineEmits<{
  "update:filters": [filters: GuestListFilters]
}>()

const filterDefaults: GuestListFilters = {
  perPage: 50,
}

const internalFiltersState = reactive<GuestListFilters>(structuredClone(filterDefaults))

onMounted(() => {
  if (props.filters?.perPage)
    internalFiltersState.perPage = props.filters.perPage
})

const { t } = useTranslation()

const perPageOptions = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "15", value: 15 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
]

watchEffect(() => {
  emit("update:filters", internalFiltersState)
})
</script>

<template>
  <Drawer :name="GuestListFiltersDrawerKey" :title="t('filter')">
    <form @submit.prevent>
      <div class="flex flex-col gap-4">
        <Select
          v-model="internalFiltersState.perPage"
          name="perPage"
          :label="t('guest_list_filters_drawer.per_page_label')"
          :items="perPageOptions"
        />
      </div>
    </form>
  </Drawer>
</template>
k
